module.exports = __webpack_public_path__ + "static/media/YF27_2.433b3460.jpg";